<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button v-if="buttonIsVisible" v-show="!isEdit && !isAssembly && !isSecondLevel && currentUser.role != 'Reader'" @click="edit" icon="edit" bold :text="lang.button_Edit" :tooltip="lang.button_Edit" :disabled="editButtonStatus" />
          <action-button v-if="buttonIsVisible" v-show="isEdit && !isAssembly" @click="unedit" icon="edit" bold
            :text="lang.button_Unedit" :tooltip="lang.button_Unedit" :disabled="uneditButtonStatus" />
          <action-button v-if="buttonIsVisible && currentUser.role != 'Reader'" v-show="!isAssembly && !isSecondLevel" @click="save" icon="save" bold 
            :text="lang.button_Save" :tooltip="lang.button_Save" :disabled="saveButtonStatus" :save="saveStatus"/>

          <action-button v-if="currentUser.role != 'Reader'" @click="derive" v-show="!isAssembly" icon="derive" bold :text="lang.button_Derive" :title="lang.button_Derive" :disabled="deriveButtonStatus" />
          <action-button v-if="currentUser.role == 'Admin' && globalSettings.deletionOfElements" @click="_delete" icon="remove" bold :text="lang.button_Delete"
            :title="lang.button_Delete" :disabled="deleteButtonStatus" />
          <action-button v-if="currentUser.role != 'Reader'" @click="removeRevision" icon="remove" bold :text="lang.button_RemoveRevision" :title="lang.button_RemoveRevision" :disabled="removeRevisionButtonStatus" />
          <action-button v-if="currentUser.role != 'Reader'" @click="withdraw" icon="withdraw" bold :text="lang.button_Withdraw" :title="lang.button_Withdraw" :disabled="withdrawButtonStatus" />
          <action-button v-if="currentUser.role == 'Admin'" @click="moveTo" icon="move-to" bold :text="lang.button_MoveTo" :title="lang.button_MoveTo" :disabled="moveToButtonStatus" />
          
          <action-button @click="search" v-show="!isAssembly && !isSecondLevel" icon="physicals" bold :text="lang.button_SearchOutside" :title="lang.button_SearchOutside" :disabled="searchButtonStatus" />
          
          <action-button v-if="!isPlugin && currentUser.role != 'Reader'" @click="addPhysical" v-show="!isAssembly && !isSecondLevel" icon="add-physical" bold :text="lang.button_AddPhysical" :title="lang.button_AddPhysical" :disabled="addPhysicalButtonStatus" />     

          <action-button v-if="buttonIsVisible && currentUser.role != 'Reader'" v-show="isAssembly && !appConf.status.isBasicBundle" @click="assignToAssembly" icon="new" bold :text="lang.button_AssignToAssembly" :tooltip="lang.AssignToAssembly" :disabled="assignToAssemblyButtonStatus" />
          <!-- <action-button v-if="buttonIsVisible" v-show="isAssembly" @click="removePart" icon="remove" bold
            :text="lang.button_RemoveFromAssembly" :tooltip="lang.button_RemoveFromAssembly" :disabled="removeFromAssemblyButtonStatus" /> -->

          <action-button v-show="currentUser.role == 'Admin' && isPending == true" @click="transferOwnership"
            icon="move-to" bold :text="lang.button_TransferOwnership" :tooltip="lang.button_TransferOwnership"
            :disabled="transferOwnershipButtonStatus" />



        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :title="lang.button_Left" :disabled="false" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :title="lang.button_Right" :disabled="false" />

        </b-navbar-nav>
      </action-bar>
      <action-content>

        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'

  import Content from "@/components/PartManager/Views/PartDetails/Middle/Content/Content"
  import { mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content
  },
  props:{
    lang: Object
  },
  data () {
    return {
      saveButtonStatus: true,
      editButtonStatus: false,
      uneditButtonStatus: true,
      transferOwnershipButtonStatus: false,
      assignToAssemblyButtonStatus: false,
      removeFromAssemblyButtonStatus: true,

      deriveButtonStatus: false,
      deleteButtonStatus: false,
      removeRevisionButtonStatus: false,
      withdrawButtonStatus: false,
      moveToButtonStatus: false,
      searchButtonStatus: false,
      addPhysicalButtonStatus: false,

      backButtonStatus: false,
      saving: false,
      pn: "",
      



    }
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      globalSettings: "globalSettings",
      isPlugin: 'isPlugin',
      appConf: 'appConf',
    }),
    isSecondLevel(){
      return this.$store.getters.isSecondLevel;
    },
    isEdit(){
      return this.$store.getters.isEditPropertyForm;
    },
    isAssembly(){
      
      if (this.$store.getters.selectedRows.length != 0){
        return this.$store.getters.selectedRows[0].col___status.assembly;
      }
      
    },
    lastRevisionHistory(){
      
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++){
        
        if (tab[i].revision > obj.revision){
          obj = tab[i];
        }
      }
      
      return obj;
    },
    selectedLastRevisionRow(){
      if (this.$store.getters.selectedRevisionRow.length == 0){
        return false;
      }
      return this.$route.query.revisionId == this.lastRevisionHistory.id;
    },
    authorityToChange(){
      return this.$store.getters.authorityToChange;
    },
    elementStatus(){
      if (this.lastRevisionHistory == undefined){
        return 
      }
      return this.lastRevisionHistory.status.display;
    },
    buttonIsVisible(){
      
      let ret = false;
      
      if (this.selectedLastRevisionRow && this.authorityToChange && this.isOwner) {
        ret = true;
      }
      
      if (this.elementStatus == "active"){
        ret = true;
      }
        
      
      return ret;
    },
    isOwner() {
      let ret = false;
      if (this.lastRevisionHistory.userId == this.currentUser.userId){
        ret = true;
      }
      return ret;
    },
    isPending() {
      
      if (this.lastRevisionHistory == undefined) {

        return false;
      }
      return this.lastRevisionHistory.status.display == "pending";
    },
    saveStatus() {
      return this.$store.getters.saveStatus;
    },
    
    

  },
  created() {


  },
  watch: {
    isEdit: function(newVal, oldVal){
      

        this.saveButtonStatus = !newVal;
        this.editButtonStatus = newVal;
        this.uneditButtonStatus = !newVal;

    },
    lastRevisionHistory: function () {

      this.loadDataForRevisions();

    },
  },

  methods: {
    loadDataForRevisions() {


      let vue = this;
 

      let obj = {
        revisionId: this.$route.query.revisionId,
        
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getPart", obj)
        .then(function (result) {
          console.log(result)

          if (result.status == "OK") {
            if (result.data != null) {
              for (let i = 0, lei = result.data.length; i < lei; i++) {
                if (result.data[i].type == "part number") {
                  vue.pn = result.data[i].value.display;
                }
              }
            }
          } else {
            
          }
          
          

        })

      

    },
    edit(){
      

      this.$store.dispatch("editPropertiesForm", true);
    },
    unedit(){
      

      this.$store.dispatch("editPropertiesForm", false);
    },
    
    save(){
      
      
      let vue = this;

      let trig = false;
        for (let i = 0, lei = this.$store.getters.propertyToSaving.length; i < lei; i++){
          
          if ((this.$store.getters.propertyToSaving[i].isRequiredOnRequest == true)&&(this.$store.getters.propertyToSaving[i].value == "")){
            trig = true;
            break;
          }
        }
        
        if (trig == true){
          let obj = {
            text: this.lang.alert_error_edit_required,
            time: 10,
            type: "danger"
          }

          this.$store.dispatch("displayFooterAlert", obj);


        }else{
          let revisionId = "";
          const tab = this.$store.getters.selectedRevisionRow
            let rev = 0;
            let revId = "";
            for (let i = 0, lei = tab.length; i < lei; i++){
              
              if (tab[i].revision > rev){
                rev = tab[i].revision;
                revId = tab[i].revisionId;
              }
              
            }
            revisionId = revId;

          let obj = {
            revisionId: revisionId,//this.$store.getters.selectedRows[0].col___revisionId.revisionId,
            values: this.$store.getters.propertyToSaving
          }

          this.$store.dispatch(this.$store.getters.sectionPrefix + "_updatePart", obj)
          .then(function(result){

            if (result.status == "OK"){

              vue.saving = true;

              let obj = {
                text: vue.lang.alert_success_edit_part,
                time: 5,
                type: "success"
              }

              vue.$store.dispatch("displayFooterAlert", obj);

              let reloadObj = {
                status: true,
                name: "RevisionTableComponent",
                source: ""
              }
              vue.$store.dispatch("reloadAfterAction", reloadObj);


              reloadObj = {
                status: true,
                name: "WhatIsIncludedForPartsComponentpartdetails",
                source: ""
              }
              vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

              vue.$store.dispatch("setSaveStatus", false);
              
            }else{

              let message = result.message;

              let obj = {
                text: vue.lang.alert_error_edit_part + ": " + message,
                time: 15,
                type: "danger"
              }

              vue.$store.dispatch("displayFooterAlert", obj);

            }



          })


        }


    },
    assignToAssembly() {
      
      let vue = this;
     

      function funcYes() {
       
      

        function funcAssemblyYes() {

          if (vue.$store.getters.assemblyQuantity.quantity <= 0) {
            let obj = {
              text: vue.lang.alert_error_AssemblyQuantity,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
            return
          }

          const obj = {
            assemblyRevisionId: vue.$store.getters.selectedRows[0].col___revisionId.revisionId,
            partRevisionId: vue.$store.getters.selectedSearchPartRows.revisionId,
            Quantity: vue.$store.getters.assemblyQuantity.quantity
          }


          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_assignAssembly", obj)
            .then((result) => {

              console.log(result)

              if (result.status == "OK") {
                if (result.data == 1) {

                  let obj = {
                    text: vue.lang.alert_success_AssignAssembly,
                    time: 10,
                    type: "success"
                  }

                  vue.$store.dispatch("displayFooterAlert", obj);

                  const reloadObj = {
                    status: true,
                    name: "RevisionTableComponent"
                  }
                  vue.$store.dispatch("reloadAfterAction", reloadObj);


                } else {
                  let obj = {
                    text: vue.lang.alert_error_AssignAssembly + ". ",
                    time: 15,
                    type: "danger"
                  }

                  vue.$store.dispatch("displayFooterAlert", obj);
                }
              } else {
                
                
                let obj = {
                  text: vue.lang.alert_error_AssignAssembly + ": " + result.message,
                  time: 15,
                  type: "danger"
                }

                vue.$store.dispatch("displayFooterAlert", obj);
              }
          })
        }
        
        //display quantity modal
        var obj = {

          text: "",
          type: "assemblyquantity",
          buttons: 2,
          size: "lm",
          //data: null,
          lang: vue.lang.modal_QuantityForAssembly,
          funcNo: "",
          funcYes: funcAssemblyYes
        };
        vue.$store.dispatch("showModalComponent", obj);

        
      }
      let data = {
        form: null,
        isCheckBoxShowAll: false
      }

      var obj = {

        text: "",
        type: "bom",
        buttons: 2,
        size: "xxl",
        data: data,
        lang: this.lang.modal_SearchParts,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalSearchPartsComponent", obj);
    },
    transferOwnership() {
      
      let vue = this;

      let funcYes = function (e) {

        let transferOwnershipForm = vue.$store.getters.transferOwnershipForm;

        

        let obj = {
          revisionId: vue.lastRevisionHistory.id,
          userId: transferOwnershipForm.userId
        }
        
        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_transferOfOwnership", obj)
          .then(function (result) {

            console.log(result)

            if (result.status == "OK") {



              if (result.data != null) {

                
                vue.$store.dispatch("setAuthorityToChange", true);

                let obj = {
                  text: vue.lang.alert_success_TransferOwnership,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);


                //reload table
                let reloadObj = {
                  status: true,
                  name: "RevisionTableComponent"
                }
                vue.$store.dispatch("reloadAfterAction", reloadObj);

                reloadObj = {
                  status: true,
                  name: "HistoryDetailsComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                reloadObj = {
                  status: true,
                  name: "TasksComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
              } else {
                let obj = {
                  text: vue.lang.alert_error_TransferOwnership + ". ",
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }

            } else {
              let obj = {
                text: vue.lang.alert_error_TransferOwnership + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

      }

        var obj = {

          text: "",
          type: "transferownership",
          buttons: 2,
          size: "lg",
          lang: this.lang.modal_TransferOwnership,
          funcNo: "",
          funcYes: funcYes
        };
        this.$store.dispatch("showModalComponent", obj);
    },
    derive() {

      let to = "/PartManager/PartDerive";


      const query = {
        from: this.$route.path,
        to: to,
        source: "PartDetails",
        //end: true,
        revisionId: this.$route.query.revisionId,
        id: this.$route.query.id
      }
      console.log(query)
      

      this.$router.push({ path: to, query: query });
      
    },
    _delete() {

      let vue = this;

      let partId = this.$route.query.id;

      let deletePartFunc = function () {

        
        const arr = {
          partIds: [partId]
        }

        
        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_bulkDeletePart", arr)
          .then((result) => {

            console.log(result)
            let obj = {};
            if (result.status == "OK") {

              if (result.data != null) {
                obj = {
                  text: vue.lang.alert_success_delete_part,
                  time: 10,
                  type: "success"
                }
                const reloadObj = {
                  status: true,
                  name: "DataTableFilteredOnApiComponent"
                }
                vue.$store.dispatch("reloadAfterAction", reloadObj);

                let to = "/PartManager/PartTable";
                const query = {
                  from: vue.$route.path,
                  to: to,
                  source: "PartDetails",
                  
                }
                
                vue.$router.push({ path: to, query: query });


              } else {
                obj = {
                  text: vue.lang.alert_error_delete_part + ". ",
                  time: 15,
                  type: "danger"
                }

              }
            } else {
              obj = {
                text: vue.lang.alert_error_delete_part + ": " + result.message,
                time: 15,
                type: "danger"
              }

            }
            vue.$store.dispatch("displayFooterAlert", obj);
          })
      }

      const obj = {
        title: vue.lang.modal_title_delete,
        text: this.lang.alert_delete,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: deletePartFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
      
    },
    removeRevision() {

      let vue = this;

      let revisionId = this.$route.query.revisionId;

      let removeFunc = function () {

        const obj = {
          partRevisionIds: [revisionId]
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_bulkRemoveRevision", obj)
          .then((result) => {

            console.log(result)
            let obj = {};
            if (result.status == "OK") {

              if (result.data != null) {

                if (result.data[0].success == true) {
                  obj = {
                    text: vue.lang.alert_success_removeRevision_part,
                    time: 10,
                    type: "success"
                  }
                  const reloadObj = {
                    status: true,
                    name: "DataTableFilteredOnApiComponent"
                  }
                  vue.$store.dispatch("reloadAfterAction", reloadObj);

                  let to = "/PartManager/PartTable";
                  const query = {
                    from: vue.$route.path,
                    to: to,
                    source: "PartDetails",

                  }

                  vue.$router.push({ path: to, query: query });
                } else {
                  obj = {
                    text: vue.lang.alert_error_removeRevision_part + ": " + result.data[0].message,
                    time: 15,
                    type: "danger"
                  }
                }
                

              } else {
                obj = {
                  text: vue.lang.alert_error_removeRevision_part,
                  time: 15,
                  type: "danger"
                }

              }
            } else {
              obj = {
                text: vue.lang.alert_error_removeRevision_part + ": " + result.message,
                time: 15,
                type: "danger"
              }

            }
            vue.$store.dispatch("displayFooterAlert", obj);
          })
      }

      const obj = {
        title: vue.lang.modal_title_removeRevision,
        text: this.lang.alert_removeRevision,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: removeFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
      
    },
    withdraw() {

      let alert_success_withdraw = this.lang.alert_success_withdraw;
      let alert_error_withdraw = this.lang.alert_error_withdraw;

      let withdrawParts = function (_vue) {
        const arr = [];


        for (var i = 0, le = _vue.$store.getters.selectedRows.length; i < le; i++) {
          arr.push(_vue.$store.getters.selectedRows[i].col___revisionId.partId)

        }

        const obj = {
          partIds: arr
        }

        _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_bulkSetWithdraw", obj)
          .then((result) => {

            console.log(result)
            if (result.status == "OK") {

              if (result.data != null) {

                if (result.data[0].success == true) {
                  let obj = {
                    text: alert_success_withdraw,
                    time: 10,
                    type: "success"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj);

                  const reloadObj = {
                    status: true,
                    name: "RevisionTableComponent"
                  }
                  _vue.$store.dispatch("reloadAfterAction", reloadObj);
                } else {
                  let obj = {
                    text: alert_error_withdraw + ": " + result.data[0].message,
                    time: 15,
                    type: "danger"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj);
                }
                

              } else {
                let obj = {
                  text: alert_error_withdraw + ": " + result.message,
                  time: 15,
                  type: "danger"
                }

                _vue.$store.dispatch("displayFooterAlert", obj);
              }

            } else {
              let obj = {
                text: alert_error_withdraw + ": " + result.message,
                time: 15,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);

            }
          })

      }

      const obj = {
        title: "Withdraw",
        text: this.lang.alert_withdraw,
        type: "withdraw",
        buttons: 2,
        size: "sm",
        funcYes: withdrawParts,
        funcNo: "",

      }

      this.$store.dispatch("showAlert", obj);
      
    },
    moveTo() {

      let vue = this;


      let funcYes = function (e) {

        let newMovingCategory = vue.$store.getters.newMovingCategory;


        let obj = {
          partIds: newMovingCategory.partIds,
          categoryId: newMovingCategory.categoryId
        }
        
        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_bulkMoveToAnotherCategory", obj)
          .then(function (result) {

            console.log(result)

            if (result.status == "OK") {



              if (result.data != null) {

                let obj = {
                  text: vue.lang.alert_success_MovePart,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);


                //reload table
                const reloadObj = {
                  status: true,
                  name: "LeftContentPartDetails"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                vue.saving = true;

                // let to = "/PartManager/PartTable";
                // const query = {
                //   from: vue.$route.path,
                //   to: to,
                //   source: "PartDetails",

                // }

                // vue.$router.push({ path: to, query: query });
              } else {
                let obj = {
                  text: vue.lang.alert_error_MovePart,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }

            } else {
              let obj = {
                text: vue.lang.alert_error_MovePart,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

      }

      var obj = {

        text: "",
        type: "moving",
        buttons: 2,
        size: "lg",
        lang: this.lang.modal_Moving,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);
      
    },
    search() {

      let to = "/PartManager/PartSearch";



      const query = {
        from: this.$route.path,
        to: to,
        source: "PartDetails",
        pn: this.pn,
        revisionId: this.$route.query.revisionId,
        id: this.$route.query.id
      }

      this.$router.push({ path: to, query: query });
    },
    addPhysical() {
      let to = "/PartManager/PartPhysicals";


      const query = {
        from: this.$route.path,
        to: to,
        source: "new",
        revisionId: this.$route.query.revisionId,
        id: this.$route.query.id
      }

      this.$router.push({ path: to, query: query });
      
    },



    back(){
      
      this.$store.dispatch("setSaveStatus", false);
      this.$store.dispatch("resetPropertyToSaving");

      if (this.saving){
        
        const reloadObj = {
            status: true,
            name: "DataTableFilteredOnApiComponent"
        }
        this.$store.dispatch("reloadAfterAction", reloadObj);
        

      }

      let to = this.$route.query.from;
      if (this.$route.query.from == "/PartManager/PartNew"){
        to = "/PartManager/PartTable";
        const reloadObj = {
            status: true,
            name: "DataTableFilteredOnApiComponent"
        }
        this.$store.dispatch("reloadAfterAction", reloadObj);
      }
      if (this.$route.query.from == "/PartManager/PartDerive"){
        to = "/PartManager/PartTable";
        const reloadObj = {
            status: true,
            name: "DataTableFilteredOnApiComponent"
        }
        this.$store.dispatch("reloadAfterAction", reloadObj);
      }
      if (this.$route.query.from == "/ProjectManager/ProjectDetails/part"){
        const goalObj = {
          revisionId: this.$store.getters.goToObject.back.revisionId,
          id: this.$store.getters.goToObject.back.id,
          to: this.$store.getters.goToObject.back.path
        }
        
        this.goTo(goalObj);
        
        return
      }
      
      if (this.$route.query.from == "/ProjectManager/ProjectBom"){
        const goalObj = {
          revisionId: this.$store.getters.goToObject.back.revisionId,
          id: this.$store.getters.goToObject.back.id,
          to: this.$store.getters.goToObject.back.path,
          selectedBomRow: this.$store.getters.goToObject.bom.selectedBomRow
        }
        
        this.goTo(goalObj);
        
        return
      }

      if (this.$route.query.from == "/LibraryManager/LibraryDetails") {
        const goalObj = {
          revisionId: this.$store.getters.goToObject.back.revisionId,
          id: this.$store.getters.goToObject.back.id,
          to: this.$store.getters.goToObject.back.path,
          
        }

        this.goTo(goalObj);

        return
      }
      if (this.$route.query.from == "/LibraryManager/LibraryTable") {
        this.$store.dispatch("deleteAllSelectedRows");
      }
      
      if (this.$route.query.end == true) {
        
        to = "/PartManager/PartTable";
      }


      

      this.$store.dispatch("deleteAllSelectedRows");
      const query = {
        from: this.$route.path,
        to: to,
        end: true,
        revisionId: this.$route.query.sourceRevisionId,
        id: this.$route.query.sourceId
      }
      
      this.$router.push({ path: to, query: query }) 


    },
    goTo(goalObj){

    
      this.$store.dispatch("projm_setSelectedBomRow", goalObj.selectedBomRow)
      
      
      let to = goalObj.to;

      let end = false;
      
      let obj = {
        col___revisionId: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }
        },
        col___revision: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }
        },
        col___status: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }
          
        },
        col___name: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }
          
        },
        col___image: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }
        },
        col___libraryType: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }
        }
      }

      if (to == "/LibraryManager/LibraryDetails") {
        let id = goalObj.id;
        end = true;
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            userId: goalObj.userId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }
          },

        }
      }
      
      
      
      
      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setSelectedRows", [obj]);
      
      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      

      
      const query = {
        from: this.$route.path,
        to: to,
        end: end,
        revisionId: this.$route.query.sourceRevisionId,
        id: this.$route.query.sourceId
      }
      console.log(query)
      this.$router.push({ path: to, query: query }) 

      
    },
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }
}
</script>


<style scoped>
  .middle{
    border-right: 1px solid #666;
    width: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartDetails/Middle/Middle.vue